import { render, staticRenderFns } from "./listasalidas.vue?vue&type=template&id=24e3abe2&scoped=true&"
import script from "./listasalidas.vue?vue&type=script&lang=js&"
export * from "./listasalidas.vue?vue&type=script&lang=js&"
import style0 from "./listasalidas.vue?vue&type=style&index=0&id=24e3abe2&scoped=true&lang=css&"
import style1 from "./listasalidas.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e3abe2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VContainer,VFlex,VLayout})
